import { CELL_STATE } from '../styles/cellStyles';

// Helper for icon circle bg (called inline in JSX)
const sty_iconCircleBase = {
  width: '52px', height: '52px', borderRadius: '50%',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  marginBottom: '12px', flexShrink: 0,
};

export const sty = {
  page: {
    minHeight: '100vh',
    fontFamily: "'Nunito', 'Nunito Sans', system-ui, sans-serif",
    color: '#1B1B2F',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '60px',
  },

  // ── Nav
  nav: {
    position: 'sticky', top: 0, zIndex: 100,
    backgroundColor: '#EDF6F9',
    borderBottom: '1px solid #e5e0d5',
    backdropFilter: 'blur(8px)',
  },
  navInner: {
    maxWidth: '1080px', margin: '0 auto', padding: '0 24px',
    height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  },
  navRight: { display: 'flex', alignItems: 'center', gap: '12px' },
  demoPill: {
    backgroundColor: '#fff8e6', color: '#92400e',
    border: '0.5px solid #fcd34d', borderRadius: '20px',
    fontSize: '12px', padding: '4px 12px',
    fontFamily: "'Nunito Sans', sans-serif", fontWeight: 600,
  },
  navCta: {
    padding: '7px 16px', fontSize: '14px', fontWeight: 700,
    backgroundColor: '#FF6B6B', color: '#fff',
    textDecoration: 'none', borderRadius: '7px',
    fontFamily: "'Nunito Sans', sans-serif",
  },
  hamburgerBtn: {
    display: 'none', flexDirection: 'column', gap: '5px',
    cursor: 'pointer', background: 'none', border: 'none', padding: '6px',
    alignItems: 'center', justifyContent: 'center',
  },
  drawerContent: { padding: '24px 20px', display: 'flex', flexDirection: 'column', gap: '16px' },
  drawerCta: {
    display: 'block', padding: '14px', textAlign: 'center',
    backgroundColor: '#FF6B6B', color: '#fff', borderRadius: '10px',
    fontWeight: 700, fontSize: '15px', textDecoration: 'none',
    fontFamily: "'Nunito Sans', sans-serif",
  },

  // ── Hero
  heroSection: {
    backgroundColor: '#1B1B2F',
    padding: '64px 24px 72px',
  },
  heroContent: {
    maxWidth: '760px', margin: '0 auto', textAlign: 'center',
  },
  heroEyebrow: {
    fontSize: '12px', color: '#83C5BE', letterSpacing: '1.2px',
    textTransform: 'uppercase', marginBottom: '16px',
    fontFamily: "'Nunito Sans', sans-serif",
  },
  heroH1: {
    fontFamily: "'Nunito', sans-serif", fontWeight: 900,
    fontSize: '34px', color: '#fff', margin: '0 0 16px', lineHeight: 1.2,
  },
  heroSub: {
    fontSize: '16px', color: 'rgba(255,255,255,0.6)', margin: '0 0 36px',
    fontFamily: "'Nunito Sans', sans-serif", lineHeight: 1.6,
  },
  roleGrid: {
    display: 'grid', gridTemplateColumns: '1fr 1fr',
    gap: '20px', maxWidth: '760px', margin: '0 auto',
  },
  startBadge: {
    position: 'absolute', top: '14px', right: '14px',
    backgroundColor: '#006D77', color: '#fff',
    fontSize: '10px', padding: '3px 10px', borderRadius: '20px',
    fontWeight: 600, fontFamily: "'Nunito Sans', sans-serif",
  },
  iconCircle: bg => ({ ...sty_iconCircleBase, backgroundColor: bg }),
  roleTitle: {
    fontFamily: "'Nunito', sans-serif", fontWeight: 900,
    fontSize: '22px', color: '#1B1B2F', marginBottom: '10px',
  },
  roleDesc: {
    fontSize: '14px', color: '#4a5568', lineHeight: 1.65,
    fontFamily: "'Nunito Sans', sans-serif", marginBottom: '12px',
  },
  roleFeatures: {
    margin: '0 0 4px 0', padding: '0 0 0 18px', flex: 1,
    fontSize: '13px', color: '#718096', lineHeight: 1.9,
    fontFamily: "'Nunito Sans', sans-serif",
  },
  roleBtnTeacher: {
    width: '100%', padding: '12px', background: '#006D77',
    color: '#fff', border: 'none', borderRadius: '8px',
    fontFamily: "'Nunito Sans', sans-serif", fontWeight: 600,
    fontSize: '15px', cursor: 'pointer', marginTop: '16px',
  },
  roleBtnStudent: {
    width: '100%', padding: '12px', background: '#FF6B6B',
    color: '#fff', border: 'none', borderRadius: '8px',
    fontFamily: "'Nunito Sans', sans-serif", fontWeight: 600,
    fontSize: '15px', cursor: 'pointer', marginTop: '16px',
  },

  // ── Shared view wrapper
  viewPage: {
    flex: 1, backgroundColor: '#EDF6F9', padding: '32px 24px',
  },
  teacherInner: { maxWidth: '680px', margin: '0 auto' },
  studentInner: { maxWidth: '520px', margin: '0 auto' },

  backLink: {
    background: 'none', border: 'none', color: '#006D77',
    fontSize: '13px', cursor: 'pointer', padding: '0',
    display: 'block', marginBottom: '20px',
    fontFamily: "'Nunito Sans', sans-serif",
    textDecoration: 'underline', textAlign: 'left',
  },

  // ── Teacher card
  teacherCard: {
    backgroundColor: '#fff', borderRadius: '12px', padding: '28px',
  },
  cardHeaderRow: {
    display: 'flex', justifyContent: 'space-between',
    marginBottom: '20px',
  },
  cardMeta: {
    fontSize: '13px', color: '#718096',
    fontFamily: "'Nunito Sans', sans-serif",
  },
  clueCard: {
    backgroundColor: '#83C5BE', borderRadius: '8px',
    padding: '16px 20px', marginBottom: '16px',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  },
  winPattern: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' },
  winPatternLabel: { fontSize: '8px', textTransform: 'uppercase', color: 'rgba(0,79,88,0.65)', letterSpacing: '1px', fontWeight: 600 },
  winPatternGrid: { display: 'grid', gridTemplateColumns: 'repeat(5, 6px)', gap: '2px' },
  winCellOn: { width: '6px', height: '6px', borderRadius: '1px', backgroundColor: '#004f58' },
  winCellOff: { width: '6px', height: '6px', borderRadius: '1px', backgroundColor: 'color-mix(in srgb, #83C5BE 30%, #EDF6F9)' },
  winCellFree: { width: '6px', height: '6px', borderRadius: '1px', backgroundColor: '#FF6B6B' },
  winPatternName: { fontSize: '8px', fontWeight: 800, color: '#004f58', letterSpacing: '1px', textTransform: 'uppercase' },
  clueCardLabel: {
    fontSize: '10px', color: '#004f58', textTransform: 'uppercase',
    letterSpacing: '1px', marginBottom: '6px',
    fontFamily: "'Nunito Sans', sans-serif", fontWeight: 600,
  },
  clueCardWord: {
    fontFamily: "'Nunito', sans-serif", fontWeight: 900,
    fontSize: '28px', color: '#1B1B2F',
  },
  nextClueBtn: {
    width: '100%', padding: '12px',
    backgroundColor: '#006D77', color: '#fff',
    border: 'none', borderRadius: '8px',
    fontFamily: "'Nunito Sans', sans-serif", fontWeight: 600,
    fontSize: '15px', cursor: 'pointer', marginBottom: '16px',
  },
  histToggle: {
    background: 'none', border: '1px solid #e5e0d5',
    borderRadius: '6px', padding: '8px 14px', width: '100%',
    textAlign: 'left', cursor: 'pointer', fontSize: '13px',
    color: '#374151', fontFamily: "'Nunito Sans', sans-serif",
    fontWeight: 600, display: 'flex', justifyContent: 'space-between',
    alignItems: 'center',
  },
  histList: {
    marginTop: '8px', display: 'flex', flexWrap: 'wrap', gap: '6px',
    padding: '12px', backgroundColor: '#f9fafb', borderRadius: '6px',
  },
  histWord: {
    fontSize: '12px', color: '#374151',
    backgroundColor: '#e5e7eb', borderRadius: '4px', padding: '3px 8px',
    fontFamily: "'Nunito Sans', sans-serif",
  },
  rosterHeading: {
    fontSize: '12px', fontWeight: 600, color: '#718096',
    textTransform: 'uppercase', letterSpacing: '0.5px',
    marginBottom: '10px', fontFamily: "'Nunito Sans', sans-serif",
  },
  rosterRow: {
    display: 'flex', alignItems: 'center', gap: '8px',
    padding: '7px 0', borderBottom: '1px solid #f0ede8',
  },
  greenDot: {
    width: '8px', height: '8px', backgroundColor: '#22c55e',
    borderRadius: '50%', flexShrink: 0,
  },
  rosterName: {
    fontSize: '13px', color: '#1B1B2F', flex: 1,
    fontFamily: "'Nunito Sans', sans-serif", fontWeight: 600,
  },
  rosterStatus: {
    fontSize: '11px', color: '#718096',
    fontFamily: "'Nunito Sans', sans-serif",
  },
  disabledRow: { display: 'flex', gap: '12px' },
  disabledBtn: {
    padding: '8px 18px', backgroundColor: '#f3f4f6', color: '#9ca3af',
    border: '1px solid #e5e7eb', borderRadius: '6px', fontSize: '13px',
    fontFamily: "'Nunito Sans', sans-serif", cursor: 'not-allowed',
    pointerEvents: 'none', opacity: 0.6,
  },

  // ── Student board
  studentCard: {
    backgroundColor: '#006D77', borderRadius: '12px', padding: '28px',
  },
  studentGrid: {
    display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)',
    gap: '3px', marginBottom: '8px',
  },
  studentCell: {
    ...CELL_STATE.default,
    borderRadius: '6px', aspectRatio: '1', display: 'flex', alignItems: 'center',
    justifyContent: 'center', fontSize: '11px', textAlign: 'center',
    padding: '4px', boxSizing: 'border-box', cursor: 'pointer',
    userSelect: 'none', fontFamily: "'Nunito Sans', sans-serif",
    lineHeight: 1.3, minHeight: '72px',
  },
  studentCellMarked: {
    ...CELL_STATE.marked,
    borderRadius: '6px',
  },
  studentCellFree: {
    ...CELL_STATE.free,
    cursor: 'default', textTransform: 'uppercase', letterSpacing: '1px', fontSize: '11px',
  },
  strikeCounter: {
    fontSize: '12px', color: '#FF6B6B', textAlign: 'center', margin: '4px 0 0',
    fontFamily: "'Nunito Sans', sans-serif",
  },
  studentBingoBtn: {
    width: '100%', backgroundColor: '#FF6B6B',
    color: '#fff', border: 'none', borderRadius: '8px',
    fontFamily: "'Nunito', sans-serif", fontWeight: 800,
    fontSize: '15px', letterSpacing: '1px', padding: '12px',
    opacity: 0.5, cursor: 'default',
  },
  bingoNote: {
    fontSize: '11px', color: '#718096', margin: '6px 0 0',
    fontFamily: "'Nunito Sans', sans-serif",
  },

  // ── Footer
  footer: {
    backgroundColor: '#EDF6F9', borderTop: '1.5px solid #c2dfe6',
    padding: '40px 5%', display: 'flex', alignItems: 'center',
    justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px',
  },
  footerNav: { display: 'flex', gap: '24px', alignItems: 'center', flexWrap: 'wrap' },
  footerLink: {
    fontSize: '13px', color: '#718096', textDecoration: 'none',
    fontFamily: "'Nunito Sans', 'Nunito', sans-serif",
  },
  footerCopy: {
    fontSize: '12px', color: '#a0aec0',
    fontFamily: "'Nunito Sans', 'Nunito', sans-serif",
  },

  // ── Sticky bar
  stickyBar: {
    position: 'fixed', bottom: 0, left: 0, right: 0,
    backgroundColor: '#1B1B2F',
    borderTop: '0.5px solid rgba(255,255,255,0.1)',
    padding: '12px 32px', display: 'flex', alignItems: 'center',
    justifyContent: 'space-between', zIndex: 500,
    flexWrap: 'wrap', gap: '10px',
  },
  stickyLeft: { display: 'flex', alignItems: 'center', gap: '12px' },
  stickyPill: {
    backgroundColor: '#fff8e6', color: '#92400e',
    border: '0.5px solid #fcd34d', borderRadius: '20px',
    fontSize: '11px', padding: '3px 10px',
    fontFamily: "'Nunito Sans', sans-serif", fontWeight: 600,
  },
  stickyText: {
    fontSize: '13px', color: 'rgba(255,255,255,0.4)',
    fontFamily: "'Nunito Sans', sans-serif",
  },
  stickySignup: {
    padding: '7px 16px', border: '1.5px solid #FF6B6B',
    color: '#FF6B6B', backgroundColor: 'transparent',
    borderRadius: '7px', fontSize: '13px',
    fontFamily: "'Nunito Sans', sans-serif", fontWeight: 600,
    textDecoration: 'none',
  },
};
